var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 27,
    viewBox: "0 0 40 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1161",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H40V26.9187H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1161)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8006 4.4499L18.4477 11.0354C18.2259 11.1704 18.0465 11.2352 17.8083 11.2763L2.40523 12.31C2.80391 13.0133 3.19877 13.7151 3.59874 14.4201L35.5278 14.4062L33.567 10.993L29.8015 4.44982L29.8006 4.4499ZM35.0581 1.92917C34.5541 1.89405 34.0438 2.00565 33.5661 2.28323H33.5518L31.378 3.54359L34.6886 9.29356L36.8625 8.04744C38.1229 7.30769 38.5635 5.6961 37.8286 4.43606L37.1467 3.24651C36.6953 2.45811 35.8983 1.98801 35.0577 1.92958L35.0581 1.92917ZM27.0298 0.00302038C27.8103 0.0741555 28.1558 1.10881 27.3426 1.68825L24.1879 3.51511L25.0972 5.0872L32.6425 0.725378C33.3733 0.301157 34.184 0.0975436 34.9728 0.116561C36.4797 0.152574 37.9292 0.952379 38.724 2.3402L39.4059 3.52975C40.6356 5.6456 39.8893 8.37051 37.7861 9.6053V9.61946L35.5979 10.8798L37.232 13.7265C37.9653 15.0255 37.232 16.2561 36.4219 16.7572L19.4274 26.6287C18.3744 27.2325 17.0055 26.8627 16.401 25.8074L12.7065 19.4062L3.0587 16.2197C2.72092 16.1072 2.39841 15.9716 2.23472 15.7099C1.51726 14.4502 0.817914 13.2116 0.1033 11.9569C-0.207197 11.4226 0.223877 10.6298 0.842354 10.5972L17.5242 9.47848L23.5205 6.00872L22.6254 4.43663L19.2152 6.4051C18.106 6.9741 17.2842 5.47096 18.3058 4.83301C21.0326 3.24319 23.708 1.71002 26.4336 0.130967C26.6518 0.0281888 26.8504 -0.0129223 27.0306 0.00350595L27.0298 0.00302038Z",
    fill: "#27509F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOil);
export default __webpack_public_path__ + "static/media/oil.d6bc4554a5e3818a61374f454b76837a.svg";
export { ForwardRef as ReactComponent };